import { ButtonElement } from '@typedream/components';
import { ButtonElement as ButtonElementType, DreamValue } from '@typedream/core';
import { PlateRenderElementProps } from '@udecode/plate-core';
import { pick } from 'lodash';
import { DreamEditor } from '../../../types';

export function ButtonElementEditor(
  props: PlateRenderElementProps<DreamValue, ButtonElementType>,
) {
  const { editor: e } = props;
  const editor = e as DreamEditor;

  return (
    <ButtonElement
      {...pick(props, ['element', 'className', 'attributes', 'children'])}
      editable
      onClickIcon={() => editor.emitter.emit('toolbar:toggle-replace-button-icon')}
    />
  );
}
